
import { useState, useEffect } from 'react';
import { supabase } from '@/integrations/supabase/client';
import { Badge } from '@/types/quests';

export const useBadgesList = () => {
  const [badges, setBadges] = useState<Badge[]>([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<Error | null>(null);

  useEffect(() => {
    const fetchBadges = async () => {
      try {
        setLoading(true);
        const { data, error } = await supabase
          .from('badges')
          .select('*')
          .order('name');
          
        if (error) throw error;
        
        setBadges(data || []);
      } catch (err) {
        console.error('Error fetching badges:', err);
        setError(err instanceof Error ? err : new Error('Unknown error fetching badges'));
      } finally {
        setLoading(false);
      }
    };

    fetchBadges();
  }, []);

  return { badges, loading, error };
};
